import Alert from "@ui-kit/feedback/alerts/Alert/Alert.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { SeatActionRequiredAlertProps } from "./SeatActionRequiredAlert.props";

/**
 * Shared alert banner for seating modals (select/remove). Renders title and optional subtitle
 * with status styling. Returns null when there is no title.
 */
export function SeatActionRequiredAlert({
  title,
  subtitle,
  status = "warning",
}: SeatActionRequiredAlertProps): JSX.Element | null {
  if (!title) return null;

  return (
    <Alert status={status} showBorder alignItems="flex-start">
      <Alert.Icon />
      <Flex flex="1" direction="column" alignItems="flex-start">
        <Alert.Title>{title}</Alert.Title>
        <Alert.Description>{subtitle ?? ""}</Alert.Description>
      </Flex>
    </Alert>
  );
}
